/**
 * useExpedienteResumen
 * Obtiene el resumen (pantalla principal §4.1) del expediente.
 */
import { useQuery } from '@tanstack/react-query';
import { getExpedienteResumen } from '@/services/expedientes.service';
import { PARTNER_ID } from '@/constants';

export function useExpedienteResumen(directoryId: string | undefined) {
  const query = useQuery({
    queryKey: ['expedientes', 'resumen', directoryId, PARTNER_ID],
    queryFn: () => getExpedienteResumen(directoryId!, PARTNER_ID),
    enabled: Boolean(directoryId),
  });

  return {
    resumen: query.data?.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
